import React from "react";
import Card from "../Card/Card";
import { AnimatePresence, motion } from "framer-motion";
import usePreloadImages from "../../../hooks/usePreloadImages";

import "./Frame.scss";

/**
 * The `Frame__card--pos-0` (& 1, 2, 3, 4) classes determine the position of the
 * card:
 * - 0: it's off-canvas, out the top
 * - 1: it's the first "preview" item
 * - 2: it's the second "preview" item
 * - 3: it's the main item
 * - 4: it's the next main item, off-canvas to the bottom
 */
const FORCE_LOADER = false;

function Frame({ anchored = null, cards = [] }) {
  const images = cards.map((card) => {
    return card.media_s3_tv_filename || card.media_url_tv || null;
  });
  const [imagesLoaded] = usePreloadImages(images);

  const loaded = FORCE_LOADER ? false : imagesLoaded;

  return (
    <div className="Frame">
      <AnimatePresence mode="wait">
        {loaded && anchored ? (
          <motion.div
            initial={{
              opacity: 0,
            }}
            exit={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{
              duration: 0.5,
              ease: "easeInOut",
            }}
          >
            {anchored.map((card, index) => {
              const target = index - (anchored.length - 1) + 3; // ok.. the target index should be 0, plus 3 because '3' is the needed class to display the main item
              // and the surrounding items will be 0, 1, 2, and 4

              return (
                <div
                  key={card.uuid || card.id}
                  className={`Frame__card Frame__card--pos-${target}`}
                >
                  <Card
                    card={card}
                    alignMedia={index % 2 === 0 ? "right" : "left"}
                    size={target > 2 ? "full" : "preview"}
                  />
                </div>
              );
            })}
          </motion.div>
        ) : (
          <motion.div
            initial={{
              opacity: 0,
            }}
            exit={{
              opacity: 0,
            }}
            animate={{
              opacity: 1,
            }}
            transition={{
              duration: 0.5,
              ease: "easeInOut",
            }}
            key="loader"
          >
            <div className="Frame__loader" />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default Frame;
